import { FormManager } from 'Shared/form_manager';

onDomReady(() => {
   document.getElementById('js-upload-file').addEventListener('click', () => {
      document.getElementById('documentDrop').click();
   });

   const documentMetaFormManager = new FormManager('editDocumentMetaForm');

   documentMetaFormManager.setValidator('editFilename', field => {
      if (!field.value.length) {
         return documentMetaFormManager.requiredError();
      }
   });
});
